module.exports = __webpack_public_path__ + "media/application/images/ui/home-icon-e74184609513b3559bea24509d9feab9.png";